export function formatPct01(v: number, digits = 1): string {
  const n = Number(v)
  if (!Number.isFinite(n)) return '-'
  return `${(n * 100).toFixed(digits)}%`
}

export function formatInt(v: number): string {
  const n = Math.floor(Number(v))
  if (!Number.isFinite(n)) return '0'
  return n.toLocaleString('pt-BR')
}

